"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var ThemeProvider_1 = require("./ThemeProvider");
function useColor(color, colorType) {
    var colors = ThemeProvider_1.useThemeContext().colors;
    return fallback_1.default(color, colors[colorType]);
}
exports.useColor = useColor;
function useRadius(radius) {
    var spacing = ThemeProvider_1.useThemeContext().spacing;
    return typeof radius === 'string' ? radius : (typeof radius === 'number' ? radius : spacing.radius) + "px";
}
exports.useRadius = useRadius;
